/*
 * lightbox.js -- zvetseni fotky z galerie + pocitadlo pasu
 * (plan 08-09, KOMP-02 a KOMP-03).
 *
 * CO TENHLE MODUL NENI: NOSITEL GALERIE.
 *
 * Galerie funguje uplne bez skriptu -- pas je nativni posuvny kontejner
 * z `carousel.php` (08-08) a KAZDY nahled je ODKAZ na plnou fotku. Bez
 * bundlu tedy uzivatel fotku porad otevre, jen se mu otevre jako
 * samostatna stranka misto modalniho okna. Tenhle modul je ENHANCEMENT:
 * klik odkazu prebere, otevre dialog a zaridi mu klavesnici.
 *
 * PROC `lightbox-ready`
 * Trida `js` se na <html> dostane VZDY (inline skript `jsclass` v <head>).
 * Kdyby na ni viselo pocitadlo, existovalo by okno -- a pri nenactenem
 * bundlu STAV -- kdy je pocitadlo videt, ale nikdo ho neaktualizuje;
 * po prvnim swipnuti by tvrdilo „1/10" u treti fotky. `init()` proto
 * pridava `lightbox-ready` az NA SVEM KONCI, stejne jako `menu-ready`
 * (07-03), `hero-ready` (08-07) a `carousel-ready` (08-08). Poradi radku
 * v `init()` je tim SOUCAST KONTRAKTU, ne kosmetika.
 *
 * PROC SE DIALOG PRESOUVA POD <body>
 * Dva duvody, oba nosne:
 *   1. `position: fixed` uvnitr predka s `transform`/`filter` prestava
 *      byt vztazene k oknu a okno by se vykreslilo uvnitr galerie.
 *      Dnes takovy predek neexistuje, ale prvni `transform` v budouci
 *      sekci by chybu zavedl tise.
 *   2. Izolace zbytku dokumentu (`inert`) se dela na PRIMYCH POTOMCICH
 *      <body>. Kdyby dialog zustal vnorene, jeho vlastni predek by se
 *      stal inertnim -- a `inert` se dedi, takze by zmrtvel i dialog.
 * Presouva se JEDNOU pri initu (`appendChild`), zadny `innerHTML`.
 *
 * PROC RUCNI FOCUS TRAP A RUCNI INERT
 * Presna kopie vzoru z `menu.js` (07-03): `inert` je Chrome 102 /
 * Safari 15.5 / Firefox 112, tedy MIMO matici podpory projektu
 * (Chrome 90, Safari 14.1, Firefox ESR 115). Modul ho proto
 * feature-detekuje a bez nej pouzije fallback `aria-hidden` +
 * `tabindex="-1"` se ZNACKOU, ktera pri zavirani vrati atribut jen tem
 * prvkum, kterym ho nasadil on sam. Knihovna typu `focus-trap` by byla
 * prvni runtime zavislost sablony, kterou kontrakt A7 nechce.
 *
 * PROC SE VELKA FOTKA VYRABI AZ PRI OTEVRENI
 * Kontrakt zada „nestahovat vsech 10 pri loadu". Nahledy to resi
 * nativnim `loading="lazy"` (rozhodnuti N4 -- zadny vlastni lazyloader);
 * PLNE fotky by ale lazy nezachranil, protoze prvni z nich je v modalnim
 * okne technicky ve viewportu. `<img>` proto v markupu vubec neni a
 * modul ho vyrabi `document.createElement()` az v okamziku otevreni --
 * pred prvnim kliknutim se z plnych fotek nestahne ani bajt. Pri zavreni
 * se prvek zase odstrani, takze druhe otevreni nemuze na zlomek vteriny
 * ukazat predchozi fotku.
 *
 * ZAMEK ROLOVANI JE JEDNORADKOVY, A JE TO ZAMER
 * `menu.js` ma na zamek 25 radku vcetne iOS triku s `position: fixed` a
 * ulozenym `scrollY`. Ten trik tam resi konkretni poruchu: panel menu
 * NEPREKRYVA cely viewport (hlavicka zustava nad nim), takze rolovani
 * pod nim je VIDET. Lightbox je neprusvitne okno pres cely viewport,
 * takze tataz porucha neni pozorovatelna -- a `position: fixed` na tele
 * by naopak pridal riziko skoku stranky pri zavreni. Kopirovat sem tech
 * 25 radku by byl presne ten copy-paste, ktery zakazuje A3.
 *
 * ZADNY NOVY STAV NA <body>. Stavy tela jsou verejny kontrakt `state.js`
 * (allowlist + invarianty, viz docs/chatbot-position-contract.md) a
 * lightbox zadny novy nepotrebuje: viditelnost nese atribut `hidden` na
 * dialogu, zamek rolovani inline styl. Modul proto `state.js` vubec
 * neimportuje.
 *
 * BEZPECNOST (threat model 08-09): zadny `innerHTML`, zadny `eval`,
 * zadna interpolace vstupu do HTML. Adresa fotky se cte z atributu
 * `data-dgal-full` a zapisuje pres `setAttribute('src')`, popisek pres
 * `setAttribute('alt')` -- tedy vzdy jako HODNOTA atributu, nikdy jako
 * kus znacky.
 */

/** Trida na <html>: "lightbox modul dobehl" (analogie `menu-ready`). */
const READY_CLASS = 'lightbox-ready';

/*
 * Selektor fokusovatelnych prvku -- shodny s `menu.js`.
 * `[tabindex]:not([tabindex="-1"])` chyti i prvky, kterym tabindex prida
 * budouci komponenta; `:not([disabled])` vynecha vypnuta pole.
 */
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

/** Marker prvku, kterym tabindex nasadil inert fallback (a jen tem). */
const INERT_MARK = 'thLbInertTabindex';

/** Jak dlouho se po scrollu ceka, nez se prepocita pocitadlo (ms). */
const SCROLL_THROTTLE = 90;

/**
 * Zaznamy o prvcich, ktere `open()` izoloval -- VCETNE jejich PUVODNIHO
 * stavu (08-16b, B6c).
 *
 * Do 08-16b se drzely jen reference a `restoreDocument()` pak plosne
 * volalo `removeAttribute('aria-hidden')` a `node.inert = false`. Prvek,
 * ktery mel `aria-hidden="true"` NEBO `inert` uz PRED otevrenim galerie
 * (napr. dekorativni klon pasu recenzi), o nej po zavreni prisel -- a
 * ctecka zacala cist obsah, ktery byl schvalne skryty.
 *
 * Tvar zaznamu:
 * `{node, hadAriaHidden, prevAriaHidden, hadInert, hadTabindex, prevTabindex}`.
 * `tabindex` se pri izolaci NEMENI (meni ho jen fallback `tagFocusablesIn()`
 * a ten si vede vlastni seznam); zaznamenava se pro symetrii, aby budouci
 * zmena izolace nemohla puvodni hodnotu tise ztratit (M23).
 */
let inertedRoots = [];

/** Prvky, kterym fallback nasadil `tabindex="-1"`. */
let taggedFocusables = [];

/** Prave otevrena galerie, nebo null. */
let active = null;

/** Prvek, na ktery se ma po zavreni vratit fokus. */
let opener = null;

/** Ulozena hodnota `body.style.overflow` z doby pred otevrenim. */
let savedOverflow = '';

/**
 * Bezpecne prevede NodeList na staticke pole.
 *
 * @param {string} selector CSS selektor.
 * @param {ParentNode} [root] Koren hledani.
 * @return {Array<Element>}
 */
function all(selector, root) {
	return Array.prototype.slice.call((root || document).querySelectorAll(selector));
}

/**
 * Umi prohlizec atribut `inert`?
 *
 * Feature-detect, ne verze prohlizece: matice se casem posune a modul se
 * ma prepnout sam (tataz uvaha jako v `menu.js`).
 *
 * @return {boolean}
 */
function supportsInert() {
	return 'inert' in document.createElement('div');
}

/**
 * Fallback izolace: vsem fokusovatelnym potomkum nasadi `tabindex="-1"`.
 *
 * ZNACKA JE PODMINKA, NE OZDOBA: bez ni by zavreni sebralo tabindex
 * i prvkum, ktere ho mely uz predtim (skryte prvky komponent, tecky
 * pasu) -- tise by tim rozbilo jejich vlastni poradi.
 *
 * @param {Element} root Koren podstromu.
 * @return {void}
 */
function tagFocusablesIn(root) {
	const items = root.querySelectorAll(FOCUSABLE);

	for (let i = 0; i < items.length; i += 1) {
		const el = items[i];
		if (el.hasAttribute('tabindex')) {
			continue;
		}
		el.setAttribute('tabindex', '-1');
		el.dataset[INERT_MARK] = '1';
		taggedFocusables.push(el);
	}

	if (root.matches(FOCUSABLE) && !root.hasAttribute('tabindex')) {
		root.setAttribute('tabindex', '-1');
		root.dataset[INERT_MARK] = '1';
		taggedFocusables.push(root);
	}
}

/**
 * Vyradi z pristupnostniho stromu i z tab poradi vsechno krome dialogu.
 *
 * @param {Element} dialog Otevreny dialog.
 * @return {void}
 */
function isolateDocument(dialog) {
	const useInert = supportsInert();
	const children = document.body.children;

	for (let i = 0; i < children.length; i += 1) {
		const node = children[i];

		if (node === dialog) {
			continue;
		}

		const record = {
			node: node,
			hadAriaHidden: node.hasAttribute('aria-hidden'),
			prevAriaHidden: node.getAttribute('aria-hidden'),
			hadInert: node.inert === true,
			hadTabindex: node.hasAttribute('tabindex'),
			prevTabindex: node.getAttribute('tabindex')
		};

		if (useInert) {
			node.inert = true;
			inertedRoots.push(record);
			continue;
		}

		node.setAttribute('aria-hidden', 'true');
		inertedRoots.push(record);
		tagFocusablesIn(node);
	}
}

/**
 * Presny opak `isolateDocument()`.
 *
 * @return {void}
 */
function restoreDocument() {
	for (let i = 0; i < inertedRoots.length; i += 1) {
		const record = inertedRoots[i];
		const node = record.node;

		/* Obnovuje se PRESNE puvodni stav, ne "zadny stav" (08-16b, B6c). */
		if (record.hadInert) {
			node.inert = true;
		} else {
			node.inert = false;
		}

		if (record.hadAriaHidden) {
			node.setAttribute('aria-hidden', record.prevAriaHidden);
		} else {
			node.removeAttribute('aria-hidden');
		}

		if (record.hadTabindex) {
			node.setAttribute('tabindex', record.prevTabindex);
		} else if (node.dataset[INERT_MARK] !== '1') {
			node.removeAttribute('tabindex');
		}
	}
	inertedRoots = [];

	for (let i = 0; i < taggedFocusables.length; i += 1) {
		const el = taggedFocusables[i];
		if (el.dataset[INERT_MARK] === '1') {
			el.removeAttribute('tabindex');
			delete el.dataset[INERT_MARK];
		}
	}
	taggedFocusables = [];
}

/**
 * Fokusovatelne prvky uvnitr dialogu.
 *
 * Seznam se pocita az v okamziku Tabu, ne pri otevreni: dialog muze
 * obsahovat prvky, ktere se objevi pozdeji (napr. sipky skryte u galerie
 * s jedinou fotkou).
 *
 * @param {Element} dialog Dialog.
 * @return {Element[]}
 */
function focusables(dialog) {
	return Array.prototype.filter.call(
		dialog.querySelectorAll(FOCUSABLE),
		(el) => el.offsetParent !== null
	);
}

/**
 * Vypise cislo do dvojice prvku pocitadla.
 *
 * @param {Element} root Koren, ve kterem pocitadlo je.
 * @param {string} selector Selektor prvku s aktualnim cislem.
 * @param {number} index Poradi od nuly.
 * @return {void}
 */
function writeCounter(root, selector, index) {
	const now = root.querySelector(selector);

	if (now) {
		now.textContent = String(index + 1);
	}
}

/**
 * Bezpecny cil media, nebo prazdno.
 *
 * Propusti jen root-relativni cestu a absolutni `http(s)` adresu -- tentyz
 * vzor jako `safeHref()` v `map.js`. Cokoli jineho (`javascript:`, `data:`)
 * vraci prazdno a volajici prvek vubec neozdrojuje.
 *
 * @param {string} url Hodnota z atributu.
 * @return {string} Adresa, nebo ''.
 */
function safeMediaSrc(url) {
	const value = String(url || '');

	if (value.startsWith('/') && !value.startsWith('//')) {
		return value;
	}

	return /^https?:\/\//i.test(value) ? value : '';
}

/**
 * Vlozi do dialogu velkou fotku daneho poradi.
 *
 * @param {object} gallery Zaznam galerie.
 * @param {number} index Poradi od nuly.
 * @return {void}
 */
function showPhoto(gallery, index) {
	const stage = gallery.dialog.querySelector('.lightbox-stage');

	if (!stage) {
		return;
	}

	const source = gallery.items[index];

	if (!source) {
		return;
	}

	/*
	 * VOLITELNÝ VIDEO-SLIDE (13-01, zpětně slučitelné rozšíření).
	 *
	 * Když položka nese `data-dgal-video` s adresou MP4, otevře se místo
	 * fotky přehrávač. Volající, kteří atribut nepoužívají -- tedy VŠICHNI
	 * dnešní (blogová galerie z 08-09) -- dostanou bajt za bajtem totéž
	 * chování jako předtím: větev se ani nespustí. Atribut se validuje
	 * stejně jako `src` fotky (root-relativní cesta nebo `http(s)`), aby
	 * podvržená hodnota nemohla otevřít `javascript:` cíl.
	 */
	const videoSrc = safeMediaSrc(source.getAttribute('data-dgal-video') || '');

	if (videoSrc) {
		const oldImg = stage.querySelector('img');

		if (oldImg) {
			stage.removeChild(oldImg);
		}

		let video = stage.querySelector('video');

		if (!video) {
			video = document.createElement('video');
			video.className = 'lightbox-video';
			video.setAttribute('controls', 'controls');
			video.setAttribute('playsinline', 'playsinline');
			video.setAttribute('preload', 'metadata');
			stage.appendChild(video);
		}

		video.setAttribute('src', videoSrc);

		gallery.index = index;
		writeCounter(gallery.dialog, '.lightbox-counter-now', index);

		return;
	}

	const oldVideo = stage.querySelector('video');

	if (oldVideo) {
		stage.removeChild(oldVideo);
	}

	let img = stage.querySelector('img');

	if (!img) {
		img = document.createElement('img');
		img.className = 'lightbox-img';
		stage.appendChild(img);
	}

	const thumb = source.querySelector('img');

	/*
	 * Popisek se PRENASI z nahledu, nikoli vymysli: obe znacky ukazuji
	 * tutez fotku, takze dva ruzne popisky by byly dve tvrzeni o jednom
	 * obrazku. Kdyz nahled popisek nema, zustane prazdny -- prazdny `alt`
	 * je platny stav (dekorativni obrazek), vymysleny text ne.
	 */
	img.setAttribute('alt', thumb ? (thumb.getAttribute('alt') || '') : '');
	img.setAttribute('src', source.getAttribute('data-dgal-full') || source.getAttribute('href') || '');

	gallery.index = index;
	writeCounter(gallery.dialog, '.lightbox-counter-now', index);
}

/**
 * Klavesnice v otevrenem dialogu: Escape zavira, Tab cykli, sipky listuji.
 *
 * Posluchac visi na DOKUMENTU, ne na dialogu: fokus se muze ocitnout
 * mimo nej (klik do adresniho radku a zpet) a Tab by pak z pasti vypadl.
 *
 * @param {KeyboardEvent} event Udalost.
 * @return {void}
 */
function onKeydown(event) {
	if (!active) {
		return;
	}

	if ('Escape' === event.key || 'Esc' === event.key) {
		close();
		return;
	}

	if ('ArrowRight' === event.key || 'ArrowLeft' === event.key) {
		event.preventDefault();
		step('ArrowRight' === event.key ? 1 : -1);
		return;
	}

	if ('Tab' !== event.key) {
		return;
	}

	const items = focusables(active.dialog);

	if (!items.length) {
		return;
	}

	const first = items[0];
	const last = items[items.length - 1];

	if (event.shiftKey && document.activeElement === first) {
		last.focus();
		event.preventDefault();
	} else if (!event.shiftKey && document.activeElement === last) {
		first.focus();
		event.preventDefault();
	}
}

/**
 * Druha pojistka pasti (vzor `menu.js`, 07-07 bod 2): fokus, ktery se do
 * dokumentu dostal jinak nez Tabem, se vrati do dialogu.
 *
 * @param {FocusEvent} event Udalost.
 * @return {void}
 */
function onFocusOutside(event) {
	if (!active) {
		return;
	}

	const target = event.target;

	if (!target || active.dialog.contains(target)) {
		return;
	}

	const items = focusables(active.dialog);

	if (items.length) {
		items[0].focus();
	}
}

/**
 * Posun o jednu fotku s prechodem pres okraj (cyklicky).
 *
 * @param {number} dir -1 nebo 1.
 * @return {void}
 */
function step(dir) {
	if (!active) {
		return;
	}

	const count = active.items.length;

	if (count < 2) {
		return;
	}

	showPhoto(active, (active.index + dir + count) % count);
}

/**
 * Otevre dialog na dane fotce.
 *
 * @param {object} gallery Zaznam galerie.
 * @param {number} index Poradi od nuly.
 * @param {Element} trigger Prvek, ktery otevreni vyvolal.
 * @return {void}
 */
function open(gallery, index, trigger) {
	if (active) {
		return;
	}

	/* NAVRAT FOKUSU: spoustec se uklada PRED jakoukoli zmenou DOM. */
	opener = trigger || document.activeElement;
	active = gallery;

	showPhoto(gallery, index);

	gallery.dialog.removeAttribute('hidden');

	savedOverflow = document.body.style.overflow;
	document.body.style.overflow = 'hidden';

	isolateDocument(gallery.dialog);

	document.addEventListener('keydown', onKeydown);
	document.addEventListener('focusin', onFocusOutside);

	const items = focusables(gallery.dialog);

	if (items.length) {
		items[0].focus();
	}
}

/**
 * Zavre dialog a vrati fokus na spoustec.
 *
 * @return {void}
 */
function close() {
	if (!active) {
		return;
	}

	const gallery = active;

	/*
	 * Posluchace se odebiraji JAKO PRVNI: `restoreDocument()` i navrat
	 * fokusu niz by jinak vystrelily `focusin` a past by fokus vratila do
	 * dialogu, ktery se prave zavira (tataz past jako v `menu.js`).
	 */
	document.removeEventListener('keydown', onKeydown);
	document.removeEventListener('focusin', onFocusOutside);

	active = null;

	restoreDocument();

	gallery.dialog.setAttribute('hidden', '');

	/* Velka fotka z DOM mizi -- druhe otevreni nesmi problesknout starou. */
	const stage = gallery.dialog.querySelector('.lightbox-stage');

	if (stage) {
		const img = stage.querySelector('img');
		if (img) {
			stage.removeChild(img);
		}

		/* Video se odstranuje ze stejneho duvodu jako fotka -- druhe otevreni
		 * nesmi problesknout predchozi zaznam, a odstraneny prvek zaroven
		 * zastavi prehravani. */
		const video = stage.querySelector('video');
		if (video) {
			stage.removeChild(video);
		}
	}

	if ('' === savedOverflow) {
		document.body.style.removeProperty('overflow');
	} else {
		document.body.style.overflow = savedOverflow;
	}

	if (opener && 'function' === typeof opener.focus) {
		opener.focus();
	}

	opener = null;
}

/**
 * Navesi obsluhu na jednu galerii.
 *
 * @param {Element} root Koren komponenty (`.dgal`).
 * @return {object|null} Zaznam galerie, nebo null.
 */
function setupGallery(root) {
	const items = all('.dgal-item', root);

	if (!items.length) {
		return null;
	}

	const dialog = root.querySelector('.lightbox');
	const track = root.querySelector('.th-carousel-track');

	const gallery = { root, dialog, items, index: 0 };

	/* POCITADLO PASU -- funguje i tehdy, kdyz galerie dialog nema. */
	if (track) {
		let timer = null;

		track.addEventListener('scroll', function () {
			if (timer !== null) {
				return;
			}

			timer = window.setTimeout(function () {
				timer = null;

				const first = track.querySelector('.th-carousel-item');

				if (!first) {
					return;
				}

				const gap = parseFloat(window.getComputedStyle(track).columnGap || '0') || 0;
				const stepWidth = first.offsetWidth + gap;

				if (stepWidth <= 0) {
					return;
				}

				const index = Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / stepWidth)));

				writeCounter(root, '.dgal-counter-now', index);
			}, SCROLL_THROTTLE);
		}, { passive: true });
	}

	if (!dialog) {
		return gallery;
	}

	/* Dialog patri pod <body> -- viz hlavicka souboru. */
	if (dialog.parentElement !== document.body) {
		document.body.appendChild(dialog);
	}

	items.forEach(function (link, i) {
		link.addEventListener('click', function (event) {
			/*
			 * Prostredni tlacitko, Ctrl/Cmd a Shift patri prohlizeci:
			 * uzivatel chce otevrit fotku ve vlastni karte, ne dialog.
			 */
			if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) {
				return;
			}

			event.preventDefault();
			open(gallery, i, link);
		});
	});

	all('.lightbox-nav', dialog).forEach(function (btn) {
		btn.addEventListener('click', function () {
			step(parseInt(btn.getAttribute('data-lightbox-dir'), 10) || 1);
		});
	});

	const closeBtn = dialog.querySelector('.lightbox-close');

	if (closeBtn) {
		closeBtn.addEventListener('click', close);
	}

	/* Klik do prazdna kolem fotky zavira -- ocekavane chovani modalu. */
	dialog.addEventListener('click', function (event) {
		if (event.target === dialog) {
			close();
		}
	});

	return gallery;
}

/**
 * Spusti modul galerie.
 *
 * Fail-open: bez jedine `.dgal` na strance se modul tise vrati a trida
 * `lightbox-ready` NEPRIBUDE -- pocitadlo tedy zustane skryte, coz je
 * spravny stav (neni co pocitat).
 *
 * POSLEDNI RADEK JE SOUCAST KONTRAKTU: `lightbox-ready` se na <html>
 * dostane teprve tehdy, kdyz vsechno vyse probehlo bez vyjimky.
 *
 * @return {void}
 */
export function init() {
	const roots = all('.dgal');

	if (!roots.length) {
		return;
	}

	roots.forEach(function (root) {
		setupGallery(root);
	});

	// AZ NA KONCI: tridou se odkryva pocitadlo, ktere uz ma kdo aktualizovat.
	document.documentElement.classList.add(READY_CLASS);
}
